import(/* webpackMode: "eager" */ "/app/apps/web/src/app/(marketing)/industries/insurance-ubi/page.tsx");
